import { render } from "./property-desc.vue?vue&type=template&id=2e93e7ea"
import script from "./property-desc.js?vue&type=script&lang=js"
export * from "./property-desc.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__